import { create } from "zustand"
import { getWeekdayDetailAPI } from "@/apis/apt-api"
import { aptSearchStore } from "@/routes/select/apt/apt-search-store"

export const weekdayDetailChartStore = create((set) => ({
  maxWeeks: 5,
  unit: "m³",
  series: [],
  period: null,

  apiGetWeekdayCompareChart: async ({ dong, ho, target_date, resource }) => {
    const { sido, kapt_code } = aptSearchStore.getState().pickApt

    const { period, datasets } = await getWeekdayDetailAPI({
      sido,
      kapt_code,
      dong,
      ho,
      target_date,
      resource
    })

    const { current_weekly, one_month_weekly, two_month_weekly } = datasets

    const series = []

    const maxWeeks = Math.max(
      ...Object.values(current_weekly).map((v) => v.length),
      ...Object.values(one_month_weekly).map((v) => v.length),
      ...Object.values(two_month_weekly).map((v) => v.length),
      5
    )

    const currColors = ["#262AF2", "#4A4EFA", "#6E72FA", "#9295FA", "#B6B9FA", "#DADDFF"]

    const oneMonthColors = ["#00B5B6", "#00D2D3", "#4DE2E2", "#80EDED", "#B3F5F5", "#E0FAFA"]

    const twoMonthColors = ["#F97316", "#FB923C", "#FDBA74", "#FED7AA", "#FFEDD5", "#FFF7ED"]

    for (let i = 0; i < maxWeeks; i++) {
      const weekName = `${i + 1}주차`

      // 2달 전
      series.push({
        id: `two-${i + 1}`,
        name: weekName,
        type: "bar",
        stack: "two",
        itemStyle: {
          color: twoMonthColors[i]
        },
        data: [0, 1, 2, 3, 4, 5, 6].map((d) => two_month_weekly[d]?.[i]?.value || 0)
      })

      // 1달 전
      series.push({
        id: `one-${i + 1}`,
        name: weekName,
        type: "bar",
        stack: "one",
        itemStyle: {
          color: oneMonthColors[i]
        },
        data: [0, 1, 2, 3, 4, 5, 6].map((d) => one_month_weekly[d]?.[i]?.value || 0)
      })

      // 현재
      series.push({
        id: `curr-${i + 1}`,
        name: weekName,
        type: "bar",
        stack: "curr",
        itemStyle: {
          color: currColors[i]
        },
        data: [0, 1, 2, 3, 4, 5, 6].map((d) => current_weekly[d]?.[i]?.value || 0)
      })
    }
    set({ series, period })
  },

  reset: () => {
    set({
      series: [],
      maxWeeks: 5,
      period: null,
      unit: "m³"
    })
  }
}))
